import React from 'react'
import './userMenu.css'

export class UserMenu extends React.Component {
    render() {
        return (
            <div className="adminMenuPage">
                <div className="title">
                    User Management
                </div>

                <div className="body">
                    <div className="systemContentMenu">
                        <ul>
                            <li>
                                <a onClick={() => window.location='/admin/Users'}>
                                    Add/Edit Users
                                </a>
                            </li>
                            <li>
                                <a onClick={() => window.location='/admin/UserIssues'}>
                                    Add/Edit User Issues
                                </a>
                            </li>
                            <li>
                                <a onClick={() => window.location='/admin/UserNotificationTest'}>
                                    Process User Notifications
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}
